import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { getLoggedInUserMapped } from '../../utils/userMapping';
import { CONTACT_CONFIG, openContact } from '../../config/contact';

/**
 * Hook quản lý trạng thái thông báo thời hạn sử dụng
 * @returns {Object} Trạng thái và các hàm xử lý
 */
export const useSubscriptionWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const checkSubscriptionStatus = () => {
      try {
        const user = getLoggedInUserMapped();
        
        if (!user || !user.expired_date) {
          setShowWarning(false);
          return;
        }

        // Xử lý format ngày - có thể có nhiều format khác nhau
        let expiryDate;
        try {
          // Thử parse với format mặc định
          expiryDate = dayjs(user.expired_date);
          
          // Nếu không hợp lệ, thử các format khác
          if (!expiryDate.isValid()) {
            // Thử format YYYY-MM-DD HH:mm:ss
            expiryDate = dayjs(user.expired_date, 'YYYY-MM-DD HH:mm:ss');
          }
          
          if (!expiryDate.isValid()) {
            // Thử format YYYY-MM-DD
            expiryDate = dayjs(user.expired_date, 'YYYY-MM-DD');
          }
        } catch (error) {
          console.error('Error parsing date:', user.expired_date, error);
          setShowWarning(false);
          return;
        }
        
        const today = dayjs();
        const daysLeft = expiryDate.diff(today, 'day');

        console.log('📅 Subscription check:', {
          originalDate: user.expired_date,
          parsedDate: expiryDate.format('YYYY-MM-DD'),
          today: today.format('YYYY-MM-DD'),
          daysLeft,
          warningDays: CONTACT_CONFIG.warningDays,
          shouldShow: daysLeft >= 0 && daysLeft < CONTACT_CONFIG.warningDays
        });

        // Hiển thị cảnh báo nếu còn dưới warningDays ngày
        if (daysLeft >= 0 && daysLeft < CONTACT_CONFIG.warningDays) {
          setDaysRemaining(daysLeft);
          setShowWarning(true);
          setIsVisible(true);
        } else {
          setShowWarning(false);
        }
      } catch (error) {
        console.error('Error checking subscription status:', error);
        setShowWarning(false);
      }
    };

    // Kiểm tra ngay lập tức khi component mount
    checkSubscriptionStatus();
    
    // Kiểm tra lại mỗi giờ
    const interval = setInterval(checkSubscriptionStatus, 60 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleContact = () => {
    openContact('email');
  };

  const handleCall = () => {
    openContact('phone');
  };

  const handleZalo = () => {
    openContact('zalo');
  };

  return {
    showWarning,
    daysRemaining,
    isVisible,
    handleClose,
    handleContact,
    handleCall,
    handleZalo
  };
}; 